import { Box, Container, Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import "./StatusScreenMs.css";
function StatusScreenMs({ status }) {
  return (
    <Grid className="ms-set-password-container">
      <div className="ms-wl-bank-logo" data-testid="svg-icon">
        <img src="/ciam/v1/static/images/ms/Worldline-Mint-Horizontal.svg" alt="Worldline" />
      </div>
      <Grid item xs={7} className="right-gradient" data-testid="right-gradient-circle">
        <img src="/ciam/v1/static/images/ms/right-circle.svg" alt="right-circular-gradient" />
      </Grid>
      <div className="ms-set-password-left">
        <Container className="ms-form-container">
          <Box>
            <Typography sx={{ fontFamily: "Nunito", whiteSpace: "pre-wrap" }}>{status?.message}</Typography>
          </Box>
        </Container>
      </div>
    </Grid>
  );
}

export default StatusScreenMs;
StatusScreenMs.propTypes = {
  status: PropTypes.object,
};
